import gql from 'graphql-tag';

export const DELETE_BILL_ITEM_MUTATION = gql`
  mutation DeleteBillItem($billItemId: ID!) {
    deleteBillItem(where: { id: $billItemId }) {
      id
    }
  }
`;
